// extracted by mini-css-extract-plugin
module.exports = {"animateSideBar":"sidebar_animateSideBar__jGEs1","sideBar":"sidebar_sideBar__XK80N","rightSide":"sidebar_rightSide__4UA7I","scrollableContent":"sidebar_scrollableContent__SEqc7"};